import script from "./UsersScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersScreen.vue?vue&type=script&setup=true&lang=js"

import "./UsersScreen.vue?vue&type=style&index=0&id=43bce509&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43bce509"]])

export default __exports__